import React, { useEffect, useState } from 'react';
import './Toast.css';

export default function Toast({ title, message, onClose, type = 'success' }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Wait for animation to finish
    }, 4000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast-overlay ${isVisible ? 'visible' : 'hidden'}`}>
      <div className={`toast-container toast-${type}`}>
        <div className="toast-icon">
          {type === 'success' && (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          )}
          {type === 'error' && (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
          )}
        </div>

        <div className="toast-content">
          <h4 className="toast-title">{title}</h4>
          <p className="toast-message">{message}</p>
        </div>

        <button className="toast-close" onClick={() => setIsVisible(false)}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div className="toast-progress"></div>
      </div>
    </div>
  );
}
